import './skeleton-shapes.less';
export const ClubMemberSkeletonShape = (
    <div className="Skeleton animation ClubMemberSkeletonShape">
        <div className="rect"></div>
    </div>
);
